var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-center-horizontal"},[_c('div',{staticClass:"icon screen"},[_c('VImg',{staticClass:"icon-hint",attrs:{"src":require('@/assets/icons/icon-hint.svg')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }